import { render, staticRenderFns } from "./reset_password_form.vue?vue&type=template&id=9e13dd2e&scoped=true"
import script from "./reset_password_form.vue?vue&type=script&lang=js"
export * from "./reset_password_form.vue?vue&type=script&lang=js"
import style0 from "./reset_password_form.vue?vue&type=style&index=0&id=9e13dd2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e13dd2e",
  null
  
)

export default component.exports